import { AutocompleteOption } from "src/app/modules/Disbursment_modules/dis-repository/pages/create-tariff/typeahead-service";


// Used in the Create Tariff component to display the functions.
export const TariffFunctions: AutocompleteOption[] = [
    { value: 'Sum', label: 'Sum', type: 'function' },
    { value: 'Multiply', label: 'Multiply', type: 'function' },
    { value: 'Subtract', label: 'Subtract', type: 'function' },
    { value: 'Range', label: 'Range', type: 'function' },
    { value: 'Bracket', label: 'Bracket', type: 'function' },
    { value: 'Service Reference', label: 'Service Reference', type: 'function' },
    { value: 'SubService Reference', label: 'SubService Reference', type: 'function' },
    { value: 'Fixed', label: 'Fixed', type: 'function' },
    { value: 'Round', label: 'Round', type: 'function' },
    { value: 'Slab', label: 'Slab', type: 'function' },
    { value: 'DataSet', label: 'DataSet', type: 'function' },
    { value: 'Round Off', label: 'Round Off', type: 'function' }

];
